var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWaitlistPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21.714,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.002 11.844c0-5.45-4.475-9.871-10.002-9.871-5.524 0-10.002 4.42-10.002 9.871 0 4.26 3.087 9.87 10.002 9.87 6.93 0 10.002-5.619 10.002-9.87zM12 19.74c-4.412 0-8.002-3.543-8.002-7.896 0-4.356 3.59-7.897 8.002-7.897 4.412 0 8.002 3.541 8.002 7.897 0 4.353-3.59 7.896-8.003 7.896zm1-8.883h3v1.974h-3v2.961h-2v-2.96H8v-1.975h3v-2.96h2zM.803 7.615A4.879 4.879 0 010 4.932C0 2.211 2.233.002 4.991.002c.948 0 1.896.264 2.721.793a11.96 11.96 0 00-6.91 6.82zM19.004 0a5.04 5.04 0 00-2.72.793c3.17 1.202 5.695 3.69 6.915 6.819A4.878 4.878 0 0024 4.93C24 2.205 21.764 0 19.004 0z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

export default SvgWaitlistPage;